export default "__VITE_ASSET__B40aKN3X__"